<template>
  <button
    :class="className"
    @click="emitClick"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    view: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['emitClick'],
  computed: {
    className() {
      return 'base-button base-button_view_' + this.view
    }
  },
  methods: {
    emitClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.base-button {
  --border-color: transparent;
  --font-color: #000;
  --bg-color: #fff;

  display: inline-flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding: 18px 20px;
  color: var(--font-color);
  font-weight: 600;
  font-size: 16px;
  font-family: inherit;
  text-transform: uppercase;
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: color .3s, border-color .3s, background-color .3s, box-shadow .3s;

  &_view {
    &_primary {
      --bg-color: #E0B453;
      --border-color: var(--bg-color);
      --font-color: #fff;

      &:hover {
        --bg-color: #fff;
        --border-color: #E0B453;
        --font-color: var(--border-color);
      }
    }

    &_secondary {
      --border-color: #E4E4E4;

      &:hover {
        box-shadow: 6px 6px 15px -3px rgba(0,0,0,0.1);
      }
    }
  }
}
</style>
